<template>
  
  <div class="buy">
    <app-header/>
    
    <div class="container">


      <div class="box-btn">
        <div class="float-right">
          <button type="button" v-b-modal.modalFilters class="btn btn-primary">
            Filtrar
          </button>
        </div>
        

        <div class="d-inline">
          <button type="button" v-on:click="generateCVS()" class="btn btn-primary">
            CSV
          </button>
        </div> 
      </div>
      
      <div class="table table-padded">
        

        <b-card mb-2>
          <b-row>
            <b-col md="6" class="my-1">
              <b-form-group horizontal label="Buscador" class="mb-0">
                <b-input-group>
                  <b-form-input v-model="filter" />
                  <b-input-group-append>
                    <b-btn :disabled="!filter" @click="filter = ''">Limpiar</b-btn>
                  </b-input-group-append>
                </b-input-group>
              </b-form-group>
            </b-col>


            <b-col md="6" class="my-1">
              <b-form-group horizontal label="Por página" class="mb-0">
                <b-form-select :options="pageOptions" v-model="perPage" />
              </b-form-group>
            </b-col>
          </b-row>

          <b-table
          
          :items="balanceBanks"
          :fields="fields"
          :current-page="currentPage"
          :per-page="perPage"
          :filter="filter"
          @filtered="onFiltered" class="table table-padded"
          >
          <template slot="id" slot-scope="row">
           {{row.item.id}}
         </template>

         

         <template slot="bankImage" slot-scope="row" > 
          <div>
            <img :src="'/banks/'+row.item.image" class="bank">
          </div>
        </template>

        <template slot="incomign" slot-scope="row">
         <h2 class="itemIndicator" :class="row.item.type == 'add' ? 'low' : ''">${{money(row.item.incomign)}}</h2>
         
       </template>


       <template slot="expenses" slot-scope="row">
         <h2 class="itemIndicator" :class="row.item.type == 'add' ? 'low' : ''">${{money(row.item.expenses)}}</h2>
       </template>

       <template slot="total" slot-scope="row">
         <h2 class="itemIndicator" :class="(row.item.incomign-row.item.expenses) < 0 ? 'low' : ''">${{money(row.item.incomign-row.item.expenses)}}</h2>
       </template>

       <template slot="action" slot-scope="row" >
        
        <button  class="actionBtnTable nobtn" v-b-modal.createUser>
          <i class="material-icons" style="color: #dab51b;" >edit</i>
        </button>
        <button class="actionBtnTable nobtn" v-b-modal.deleteUser >
          <i class="material-icons"  style="color: #dab51b;">delete_outline</i>
        </button>   
        
        
      </template> 
      

    </b-table>

    <b-row>
      <b-col md="12" class="my-1 float-right">
        <b-pagination :total-rows="balanceBanks.length" :per-page="perPage" v-model="currentPage" class="my-0" />
      </b-col>
    </b-row>


  </b-card >
  

</div>

</div>

<app-footer/>








<b-modal id="modalFilters" ref="modalFilters" title="Filtrar" hide-footer>
  <form v-on:submit.prevent="read">

    <div class="form-group">
      <label>Banco</label>
      <select class="form-control" name="bankId"  v-model='filters.bankId'>
        <option>Seleccione un banco</option>
        <option v-for="(bank, index) in banks" :key="index" :value="bank.id">{{bank.name}}</option>
      </select>
    </div>     


    <div class="form-group">
      <label>Fecha inicio</label>
      <input type="date" class="form-control" v-model="filters.dateStart">
    </div>

    <div class="form-group">
      <label>Fecha final</label>
      <input type="date" class="form-control" v-model="filters.dateEnd">
    </div> 

    

    <div class="d-inline">
      <button type="submit" class="btn btn-primary">Filtrar</button>
    </div>
  </form>

  

</b-modal>




</div>
</template>


<script>
import { mapGetters } from "vuex";
import { FETCH_BANKS, FETCH_BALANCEBANKS } from "@/store/actions.type";
import { required } from "vuelidate/lib/validators";

import AppHeader from "@/components/AppHeader.vue";
import AppFooter from "@/components/AppFooter.vue";
import AppPagination from "@/components/AppPagination.vue";

export default {
  components: {
    AppHeader,
    AppFooter,
    AppPagination
  },
  data: function() {
    return {
      filters: {
        dateStart: this.formatDate(Date.now()),
        dateEnd: this.formatDate(Date.now()),
        bankId: ""
      },
      data: {},
      currentPage: 1,
      perPage: 10,
      pageOptions: [5, 10, 15, 20, 30, 40, 50],
      filter: null,
      fields: [
        { key: "id", label: "Id", sorteable: true },
        { key: "bankImage", label: "Banco", sorteable: true },
        { key: "incomign", label: "Ingresos", sorteable: true },
        { key: "expenses", label: "Egresos", sorteable: true },
        { key: "total", label: "Total", sorteable: true }
      ]
    };
  },

  validations: {
    requestBuy: {
      dateStart: {
        required
      },
      carrierId: {
        required
      },
      valueBuy: {
        required,
        min: 4
      }
    }
  },

  mounted() {
    this.$store.dispatch(FETCH_BANKS);
    this.read();
  },
  methods: {
    read() {
      this.$refs.modalFilters.hide();
      this.$store.dispatch(FETCH_BALANCEBANKS, this.filters);
    },

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    clearFilter() {
      (this.filters = {}), this.read();
    },

    generateCVS() {
      var rows = this.balanceBanks.map(item => {
        return [
          item.id,
          item.name,
          item.incomign,
          item.expenses,
          "$" + (item.incomign - item.expenses)
        ];
      });

      rows = [
        ["Id", "Banco", "Ingresos", "Egresos", "Total"],
        ...rows,
        ["", "", "", "", ""]
      ];

      let csvContent = "";
      rows.forEach(function(rowArray) {
        rowArray = rowArray.map(c => `"${c}"`);
        let row = rowArray.join(";");
        csvContent += row + "\r\n";
      });
      var hiddenElement = document.createElement("a");
      hiddenElement.href =
        "data:text/csv;charset=utf-8," + encodeURI(csvContent);
      hiddenElement.target = "_blank";
      hiddenElement.download = "Saldo_Bancos.csv";
      hiddenElement.click();
    }
  },
  computed: {
    ...mapGetters(["banks", "balanceBanks"])
  }
};
</script>


<style lang="scss">
.buy {
  input {
  }

  label {
    color: #7b7b7b;
    font-weight: 900;
    font-size: 18px;
  }
  select {
    -webkit-appearance: none;
  }

  .box-modal {
    h5 {
      color: #dab51b !important;
      font-weight: 900;
      font-size: 25px;
    }
  }

  .table-head {
    background: #dab51b;
    border: none;
    color: white;
  }
}
</style>
